import { useEffect, useState } from "react";
import { ArrowRightLeft } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { TRY } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Combobox } from "@/components/Combobox";

// Hızlı satışı seçilen carinin Cari Defter'ine aktarır (stok tekrar düşülmez)
export function CariTransferDialog({ sale, isAdmin, contactOptions, onClose, onDone }) {
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setTitle(sale?.title || ""); }, [sale]);

  const save = async () => {
    if (!title.trim()) return toast.error("Müşteri / cari seçin");
    setSaving(true);
    try {
      await api.post(`/quick-sales/${sale.id}/to-cari`, { contact_title: title.trim() });
      toast.success(`'${title.trim()}' cari defterine aktarıldı`);
      onDone();
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!sale} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-[96vw] sm:max-w-md" data-testid="qs-cari-dialog">
        <DialogHeader><DialogTitle className="font-head text-xl flex items-center gap-2"><ArrowRightLeft className="h-5 w-5 text-emerald-600" />Cariye Aktar</DialogTitle></DialogHeader>
        {sale && (
          <>
            <p className="text-sm text-muted-foreground">Bu satıştaki ürünler seçilen müşterinin <b>Cari Defter</b>'ine (aldığı ürünler) eklenir. Stok tekrar düşülmez.</p>
            <div>
              <Label className="text-xs text-muted-foreground">Müşteri / Cari</Label>
              <div className="mt-1">
                <Combobox options={contactOptions} value={title} onChange={setTitle} allowCustom placeholder="Cari seçin veya yazın" searchPlaceholder="Ünvan / VKN / TCKN ara..." data-testid="qs-cari-contact" />
              </div>
            </div>
            <div className="rounded-lg border bg-muted/30 p-2.5 text-sm">
              <div className="font-medium mb-1">{sale.item_count} kalem aktarılacak</div>
              {isAdmin && <div className="text-muted-foreground">Toplam: <b className="text-foreground">{TRY(sale.grand_total)}</b></div>}
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <Button variant="outline" onClick={onClose} data-testid="qs-cari-cancel">Vazgeç</Button>
              <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="qs-cari-save"><ArrowRightLeft className="h-4 w-4 mr-1.5" />{saving ? "Aktarılıyor..." : "Cariye Aktar"}</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
